module.exports = __webpack_public_path__ + "img/hot.149845ec.png";